import { Text } from '@chakra-ui/react';
import DataTableCard from './DataTableCard';
import ValidationBadge from './ValidationBadge';

interface GapInInsuranceImmediatelyPriorProps {
  data?: any;
}

const GapInInsuranceImmediatelyPrior = ({
  data,
}: GapInInsuranceImmediatelyPriorProps) => {
  const drivers = data?.drivers || [];

  const headers = ['Driver', 'Remarks', 'Outcome'];
  const rows = drivers.map((driver: any) => [
    driver.name,
    driver.remarks || (
      <Text color="gray.400" fontStyle="italic" fontSize="sm">
        No remarks
      </Text>
    ),
    <ValidationBadge status={driver.isValid ? 'pass' : 'caution'} />,
  ]);

  return (
    <>
      <DataTableCard headers={headers} rows={rows} />
    </>
  );
};

export default GapInInsuranceImmediatelyPrior;
